import React, { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { motion, AnimatePresence } from "framer-motion";
import { X, Trash2, Save } from "lucide-react"; // 🔥 Modern ikonok Lucide-ből

const DrawingModal = ({
  selectedOrder,
  drawingData,
  signatureRef,
  handleSaveDrawing,
  handleClearDrawing,
  isModalOpen,
  closeModal,
}) => {
  const modalRef = useRef(null);

  // Bezárás külső kattintásra
  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isModalOpen]);

  return (
    <AnimatePresence>
      {isModalOpen && selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4">
          <motion.div
            ref={modalRef}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="bg-white p-6 rounded-2xl shadow-2xl w-full max-w-[1000px] h-[800px] flex flex-col"
          >
            {/* Fejléc */}
            <div className="flex justify-between items-center border-b pb-4 mb-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                ✏️ Schiță pentru Comanda #{selectedOrder.orderNumber}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-800 transition text-2xl"
              >
                <X size={26} />
              </button>
            </div>

            {/* Rajzoló vagy kép */}
            <div className="flex-grow flex justify-center items-center border border-gray-300 rounded-lg overflow-hidden bg-gray-100">
              {drawingData && drawingData !== "N/A" ? (
                <img
                  src={drawingData}
                  alt="Schiță"
                  className="object-contain w-full h-full"
                />
              ) : (
                <SignatureCanvas
                  ref={signatureRef}
                  penColor="black"
                  canvasProps={{
                    width: 950,
                    height: 613,
                    className: "w-full h-full",
                  }}
                />
              )}
            </div>

            {/* Gombok */}
            <div className="flex justify-between items-center mt-6 space-x-4">
              {drawingData && drawingData !== "N/A" && (
                <button
                  className="flex-1 bg-orange-500 text-white py-3 rounded-lg shadow-md hover:bg-orange-600 transition flex items-center justify-center gap-2"
                  onClick={handleClearDrawing}
                >
                  <Trash2 size={20} /> Șterge Schița
                </button>
              )}

              {!drawingData || drawingData === "N/A" ? (
                <button
                  className="flex-1 bg-green-600 text-white py-3 rounded-lg shadow-md hover:bg-green-700 transition flex items-center justify-center gap-2"
                  onClick={handleSaveDrawing}
                >
                  <Save size={20} /> Salvează Schița
                </button>
              ) : null}

              <button
                className="flex-1 bg-red-500 text-white py-3 rounded-lg shadow-md hover:bg-red-600 transition flex items-center justify-center gap-2"
                onClick={closeModal}
              >
                <X size={20} /> Închide
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DrawingModal;
